import React__default from 'react';
import { ArticlePromo } from '../article-promo/article-promo.esm.js';
import '@costar-ui/cosmos';
import { ArticleTitle, ArticleTitleVariants } from '../atoms/article-title/article-title.esm.js';
import { CategoryBar } from '../atoms/category-bar/category-bar.esm.js';

var ArticleListWithFeaturedAuthor = function ArticleListWithFeaturedAuthor(_ref) {
  var authorCardComponents = _ref.authorCardComponents;
  var authorCards = authorCardComponents === null || authorCardComponents === void 0 ? void 0 : authorCardComponents.map(function (data, index) {
    var articleTitle_ = /*#__PURE__*/React__default.createElement(ArticleTitle, {
      articleTitleVariant: ArticleTitleVariants.ArticleTitleMedium
    }, data === null || data === void 0 ? void 0 : data.articleTitleElement);
    var categoryBarElement_ = /*#__PURE__*/React__default.createElement(CategoryBar, null, data === null || data === void 0 ? void 0 : data.categoryBarElement);
    return /*#__PURE__*/React__default.createElement("article", {
      className: "col-span-5 grid gap-2 sm:max-lg:col-span-3",
      key: "article-list-featured-author-".concat(index)
    }, /*#__PURE__*/React__default.createElement(ArticlePromo, {
      articleTitleElement: articleTitle_,
      categoryBarElement: categoryBarElement_
    }), data === null || data === void 0 ? void 0 : data.contactCard);
  });
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "author-cards-list",
    className: "grid grid-cols-5 gap-4 lg:mx-0 sm:max-lg:grid-cols-6"
  }, authorCards);
};

export { ArticleListWithFeaturedAuthor };
//# sourceMappingURL=article-list-with-featured-author.esm.js.map
